"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CheckboxSelected = props => {
  const {
    height,
    width
  } = props;
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "22",
    height: "22",
    x: "1",
    y: "1",
    fill: "#72D74D",
    stroke: "#FFF",
    strokeWidth: "2",
    rx: "4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#FFF",
    d: "M6.75 12.15L3.6 9 2.55 10.05 6.75 14.25 15.75 5.25 14.7 4.2z",
    transform: "translate(3 3)"
  })));
};

CheckboxSelected.defaultProps = {
  height: 24,
  width: 24
};
var _default = CheckboxSelected;
exports.default = _default;